import Cookies from 'js-cookie'
// eslint-disable-next-line import/no-extraneous-dependencies
import { UserSession } from '@amplitude/analytics-core'
import { AMPLITUDE_COOKIE_KEY } from '@/constants/amplitude'

// https://github.com/amplitude/Amplitude-TypeScript/blob/main/packages/analytics-client-common/src/storage/cookie.ts#L105
function decodeAmplitudeCookie(value: string) {
  try {
    return JSON.parse(decodeURIComponent(atob(value)))
  } catch {
    return undefined
  }
}

export function getAmplitudeCookieValue(): UserSession {
  const encondedValue = Cookies.get(AMPLITUDE_COOKIE_KEY)

  return decodeAmplitudeCookie(encondedValue || '{}')
}
